import { PaymentValues, ValueTypes, initialPaymentValues, sumClientValues, sumPolicemanValues } from "./data";

export type PaymentValueReducerActions = 
  | 'REWRITE_STATE'
  | 'PR_PAYMENT_VALUE'
  | 'PR_TOLL_VALUE'
  | 'PR_EXIT_VALUE'
  | 'REC_PAYMENT_VALUE'

export type PaymentReducerAction = {
  type: PaymentValueReducerActions;
  valueKey?: keyof PaymentValues;
  valueType?: 'hourValue' | 'kmValue';
  payload: number;
  initPayload?: ValueTypes;
}  

export function paymentValueReducer(
  state: ValueTypes = initialPaymentValues,
  action: PaymentReducerAction
): ValueTypes {
  switch (action.type) {
    case 'REWRITE_STATE':
      if (!action.initPayload) throw new Error();

      return { ...action.initPayload };
    case 'REC_PAYMENT_VALUE':
      if (!action.valueKey || !action.valueType) throw new Error();
      if (action.payload < 0) {
        return { ...state };
      } 

      const recPayment = action.valueType === 'hourValue'
        ? state.client.hourValue
        : state.client.kmValue;
      
      recPayment[action.valueKey] = action.payload;
      recPayment.total = recPayment.additional * recPayment.baseValue;

      state.client[action.valueType] = recPayment;

      state.client.rec = sumClientValues(state.client)

      return { ...state };
    case 'PR_PAYMENT_VALUE':
      if (!action.valueKey || !action.valueType) throw new Error();
      if (action.payload < 0) {
        return { ...state };
      } 

      const prPayment = action.valueType === 'hourValue'
        ? state.policeman.hourValue
        : state.policeman.kmValue;
      
      prPayment[action.valueKey] = action.payload;
      prPayment.total = prPayment.additional * prPayment.baseValue;

      state.policeman[action.valueType] = prPayment;

      state.policeman.pr = sumPolicemanValues(state.policeman)

      return { ...state };
    case 'PR_EXIT_VALUE':
      state.policeman.exitValue = action.payload;
      state.policeman.pr = sumPolicemanValues(state.policeman);

      return { ...state };
    case 'PR_TOLL_VALUE':
      state.policeman.tollValue = action.payload;
      state.policeman.pr = sumPolicemanValues(state.policeman);

      return { ...state };
  }
}